/* import __COLOCATED_TEMPLATE__ from './cta-buttons.hbs'; */
import { and, reads } from '@ember/object/computed';
import { classNames } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { service } from '@ember/service';
// eslint-disable-next-line no-restricted-imports -- loading state is visible only while this task's real fade-in delay is running
import { timeout as realTimeout, task } from 'ember-concurrency';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './cta-buttons.module.scss';

@classic
@classNames(styles.component)
export default class PracticeWebsiteCtaButtons extends Component {
  @service request;
  @service currentPractice;
  @service analytics;
  @service websiteWidget;

  @and('model.showRequestAppointmentLink', 'currentPractice.requestAsNewClient') showRequestBtn;
  @reads('currentPractice.useBookAppointmentLanguage') useBookAppointmentLanguage;
  @reads('openSchedulingWidgetTask.isRunning') isLoading;

  @computed('model.showContactCta', 'showRequestBtn')
  get firstBtnClassName() {
    return this.showRequestBtn ? 'pw-secondary' : 'pw-primary';
  }

  @(task(function* () {
    this.analytics.trackAnonymously('Appointment Request Opened', {
      object: 'Appointment Request',
      action: 'Opened',
      'source_application': 'Professional Website',
    });
    let previewModel = this.preview ? this.model : undefined;
    yield this.websiteWidget.revealTask.perform(previewModel);
    yield realTimeout(400); // widget fade in animation delay
  }).drop())
  openSchedulingWidgetTask;
}
